import { z } from 'zod';

export const getFeedbackSchema = z.object({
  feedback_id: z.string().min(1),
});

export type GetFeedbackPayload = z.infer<typeof getFeedbackSchema>;
